package com.elan.edubridge.shared.domain.model

import kotlinx.serialization.Serializable

/**
 * 관찰자 링크 상태(§2.4).
 *
 * 문자열 값은 `functions/`의 TS와 반드시 동일하다: PENDING | ACTIVE | REVOKED.
 */
@Serializable
enum class LinkStatus { PENDING, ACTIVE, REVOKED }

/**
 * 학생 문서에 붙는 보호자 연락처(§2.5).
 *
 * 현행 `StudentData.parentContact`가 `"부모님 연락처: 010-…"`이라는 표시 문자열이라
 * 파싱도 검색도 불가능했다. 개인정보이므로 변경은 `updateStudent` 콜러블 경유 + 감사 로그 대상이다.
 */
@Serializable
data class GuardianContact(
    val name: String,
    val phone: String,
    /** "모", "부", "조부" 등 자유 입력. */
    val relation: String,
)

/**
 * 관찰자 링크의 유일한 원천(§2.4). `edubridge_academies/{academyId}/guardianLinks/{linkId}`.
 *
 * 전화번호 일치로 자동 생성하지 않는다. 초대 수락만이 생성 경로다.
 * 한 학부모가 여러 자녀, 한 학생이 여러 보호자를 모두 지원한다.
 */
@Serializable
data class GuardianLink(
    val academyId: String,
    val guardianUserId: String,
    /** `academies/{academyId}/students/{studentId}` */
    val studentId: String,
    /** 학생이 계정을 가진 경우에만 채워진다. */
    val studentUserId: String? = null,
    val studentName: String,
    val relation: String,
    val status: LinkStatus,
    val linkedAt: String? = null,
) {
    /** 관찰 범위는 ACTIVE 링크로만 한정한다. REVOKED 링크의 미러는 트리거가 삭제한다(§4.4). */
    val isObservable: Boolean get() = status == LinkStatus.ACTIVE

    /**
     * 서버의 결정적 문서 id — `{studentId}_{guardianUserId}`(`functions/src/common/db.ts`
     * `guardianLinkId()`). 학생·보호자 쌍당 링크가 하나뿐이라 필드로 저장할 필요가 없다.
     *
     * `revokeGuardianLink(academyId, linkId)`에 넘기는 값이다. 세 lane이 각자 조합식을
     * 다시 쓰면 서버 규칙이 바뀔 때 조용히 어긋나므로 여기 한 곳에 둔다.
     */
    val linkId: String get() = "${studentId}_$guardianUserId"
}
